import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Signs off an inbound MN-CMS message (records GP + timestamp) so it counts as
// reviewed. POST /mncms/inbound-messages/{id}/sign-off.
export const useSignOffMncmsInboundMessage = () => {
  const queryClient = useQueryClient();
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useMutation({
    mutationFn: async (id) => {
      const axios = createAxiosInstance();
      const response = await axios.post(
        `${tenantVal}/mncms/inbound-messages/${id}/sign-off`
      );

      return response.data?.data ?? response.data;
    },
    onSuccess: () => {
      toast.success("Message signed off.");
      queryClient.invalidateQueries({ queryKey: ["mncmsInboundMessages"] });
      queryClient.invalidateQueries({ queryKey: ["mncmsInboundMessage"] });
    },
    onError: (error) => {
      toast.error(
        error?.response?.data?.message ||
          "Failed to sign off the message. Please try again."
      );
    },
    meta: { skipGlobalError: true },
  });
};
